import MasterLayout from "@/layouts/master";
export default [
	{
    path: "/admin",
    component: MasterLayout,
    children: [
      {
        path: "usuarios",
        name: "admin.usuarios",
        component: () => import("@/views/admin/usuarios/index.vue")
      },
    ]
  }
]